/**
 * 历史记录
 */

import { historyApi, deleteHistory } from '@/api/history';
import { formatToDateTime } from '@/utils/dateUtil';

// 历史记录
export const historicRecordsMixin = {
  data() {
    return {
      formatToDateTime,
      loading: false,
      noMore: false,
      userId: '',
      pager: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      typeOptions: [
        { label: '全部', value: 0 },
        { label: '成果分析', value: 1 },
        { label: '需求分析', value: 2 },
        { label: '专家查询', value: 3 },
        { label: '技术问答', value: 4 },
      ],
      currentValue: 0,
      historyData: [],

      deleteVisible: false, // 删除确认
      deleteId: '',
      deleteType: '',
    }
  },
  created() {
    this.userId = this.$store.state.id || localStorage.getItem('at_userId');
    this.historyList();
  },
  methods: {
    // 切换 类型
    handleTypeChange(val) {
      // console.log(val);
      this.currentValue = val;
      this.pager.pageNum = 1;
      this.historyList();
    },
    // 切换页码
    handleCurrentChange(v) {
      this.pager.pageNum = v;
      this.historyList();
    },
    // 历史记录
    historyList() {
      this.loading = true;
      let pa = {
        user: this.userId,
        type: this.currentValue,
        pageNum: this.pager.pageNum,
        pageSize: this.pager.pageSize,
      };
      historyApi(pa).then(res => {
        this.historyData = res.data || [];
        this.pager.total = res.total || 0;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      })
    },
    // 跳转详情
    toDetails(item) {
      let pa = {};
      switch (item.type) {
        case 'achievement':
          pa['name'] = 'resultsDetails';
          pa['query'] = { id: item.id };
          break;
        case 'demand':
          pa['name'] = 'requirementDetails';
          pa['query'] = { questionId: item.id };
          break;
        case 'scholar_query':
          pa['name'] = 'scholarSearchHistory';
          pa['params'] = { id: item.id };
          break;

        // 技术问答跳转历史记录
        case 'tech_generate':
          pa['name'] = 'technicalQAHistory';
          pa['params'] = { id: item.id };
          break;
        default:
          break;
      }
      if (this.$route.name === 'historicRecordsGuoJiao') {
        pa['name'] = `${pa['name']}GuoJiao`;
      }
      this.$router.push(pa);
    },
    // 删除弹窗
    handleDelete(item) {
      // console.log(item);
      this.deleteId = item.id;
      this.deleteType = item.type;
      this.deleteVisible = true;
    },
    // 确认删除
    handleDeleteConfirm() {
      let pa = {
        id: this.deleteId,
        type: this.deleteType,
      };
      deleteHistory(pa).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          if (this.historyData?.length === 1 && this.pager.pageNum !== 1) {
            this.pager.pageNum = this.pager.pageNum -1;
          }
          this.historyList();
        } else {
          this.$message.error(res.message);
        }
        this.deleteId = this.deleteType = '';
      });
    },
  },
}
